import Backdrop, { type BackdropProps } from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface MuiLoaderBackdropProps extends Omit<BackdropProps, 'open'> {
  $isLoading?: boolean;
  blur?: number;
  height?: string;
}

const LoaderBackdrop = ({ $isLoading = false, blur = 3, height, sx, ...rest }: MuiLoaderBackdropProps) => {
  return (
    <Backdrop
      open={$isLoading}
      sx={{
        position: 'absolute', // To cover the parent element
        backdropFilter: `blur(${blur}px)`,
        height: height || '100%',
        ...sx,
      }}
      {...rest}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoaderBackdrop;